var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.536 2.47c.26-.26.68-.26.94 0l3.053 3.053c.42.42.12 1.14-.473 1.14H4.943a.663.663 0 01-.467-1.133l3.06-3.06zM4.943 9.33h6.12c.593 0 .886.72.466 1.14l-3.06 3.06c-.26.26-.68.26-.94 0l-3.06-3.06a.669.669 0 01.474-1.14z",
    fill: "#98A2B3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort.a8f610a28227c8c088e02ea93e09e67b.svg";